export const URLConfig = {
	AppUrl: process.env.NEXT_PUBLIC_API_URL,
	AppBaseUrl: process.env.NEXT_PUBLIC_API_BASE_URL,
	MarketUrl: process.env.NEXT_PUBLIC_API_MARKET_URL,
	FileUrl: process.env.NEXT_PUBLIC_API_FILE_URL,
	FileHost: process.env.NEXT_PUBLIC_API_FILE_HOST,
	PanelAppName: process.env.NEXT_PUBLIC_PANEL_APP_NAME
} as const
